import axios from "axios";
import { DataProvider } from "react-admin";
import { SiteContryEnum } from "shared/enums/globalEnums";
import { getRawUrlBase, RteCommunicationV2ResourcesEnum, SiteResourcesEnum } from "shared/enums/resourceMappings";
import { getSitePowerBounds } from "../shared/utils";

export const getRteCode = async (
  dataProvider: DataProvider,
  code_tm: string,
  country: SiteContryEnum,
): Promise<string | null> => {
  if (process.env.REACT_APP_ENVIRONNEMENT === "production" && country === SiteContryEnum.France) {
    const { data: rteData } = await dataProvider.getList(RteCommunicationV2ResourcesEnum.RteCommunicationConfig, {
      filter: {
        code_tm: code_tm,
      },
    });
    return rteData && rteData.length > 0 ? rteData[0].id : null;
  }
  return code_tm;
};

export const fetchSiteRecord = async (
  dataProvider: DataProvider,
  record_asset_id: string,
): Promise<Record<string, unknown>> => {
  const { data: airtableData } = await axios({
    method: "get",
    url: `${getRawUrlBase(SiteResourcesEnum.SiteRecord)}${record_asset_id}/record`,
  });

  if (!airtableData) {
    throw new Error("No data returned from Airtable");
  }

  airtableData.rte_code = await getRteCode(dataProvider, airtableData.rte_code, airtableData.country);

  const powerBounds = getSitePowerBounds(airtableData.nominal_power);
  if (powerBounds) {
    airtableData.min_power_mw = powerBounds.min_power_mw;
    airtableData.max_power_mw = powerBounds.max_power_mw;
  }

  return airtableData;
};
